/*
 * Copyright (c) Domotz Ltd. All rights reserved.
 */

import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import intl from 'react-intl-universal';

import { getCountryName } from "./GeoCountries";

import UnsplashLogo from '../../assets/image/logo/unsplash_Logo.png';
import PlaceHolder from '../../assets/image/placeholder/500x750.png';

/**
 * Renders a carousel of place
 */

class PlaceCarousel extends Component {

    constructor(props) {
        super(props);

        this.state = {
            items: (this.props.items || [])
        };

    }

    componentDidMount() {
       this.mainFetchSequence(this.state.items)
    }

    mainFetchSequence(propsItems) {
        const items = propsItems.slice(0);
        items.forEach((item, index) => {

            if (!item)
                return;

            const url = item.cityName && item.regionName && item.countryCode ?
                getCountryName(item.countryCode) + '/' + item.regionName + '/' + item.cityName :
                item.regionName && item.countryCode ? getCountryName(item.countryCode) + '/' + item.regionName :
                    item.countryCode ? getCountryName(item.countryCode) : null;

            if (!url)
                return;

            fetch('/rest/place/image/' + url)
                .then(response => this.validateRestResponse(response))
                .then(response => response.json())
                .then(imageReference => {
                    /*
                        WARNING: we're cloning the Place object here manually. Must be kept aligned!

                     */
                    let clone = {
                        countryCode: item.countryCode,
                        regionName: item.regionName,
                        cityName: item.cityName,
                        imageReference: imageReference
                    };

                    this.setState(prevState => {
                        let newItems = prevState.items.slice(0);
                        newItems[index] = clone;
                        return { items: newItems };
                    });
                })
                .catch(e => this.catchRestError(e));
        }
        );
    }

    validateRestResponse(response) {
        if (response.status !== 200) {
            throw Error(response.statusText);
        }
        return response;
    }

    catchRestError(response) {
    }

    render() {
        return this.renderCarousel(this.state.items);
    }

    renderCarousel(itemList) {
        if (itemList.length === 0)
            return '';


        return (
            <div>
                <div className="js-slick-carousel slick slick-equal-height slick-gutters-2 mb-5"
                    data-hs-slick-carousel-options='{
                    "prevArrow": "<span class=\"fas fa-arrow-left slick-arrow slick-arrow-primary slick-arrow-left slick-arrow-offset slick-arrow-centered-y rounded-circle \"></span>",
                    "nextArrow": "<span class=\"fas fa-arrow-right slick-arrow slick-arrow-primary slick-arrow-right slick-arrow-offset slick-arrow-centered-y rounded-circle \"></span>",
                    "slidesToShow": 5,
                    "dots": true,
                    "dotsClass": "slick-pagination mt-3",
                    "responsive": [{
                        "breakpoint": 1200,
                       "settings": {
                        "slidesToShow": 4
                       }
                     }, {
                        "breakpoint": 992,
                       "settings": {
                        "slidesToShow": 3
                       }
                     }, {
                        "breakpoint": 768,
                       "settings": {
                        "slidesToShow": 2
                       }
                     }, {
                        "breakpoint": 554,
                       "settings": {
                        "slidesToShow": 1
                       }
                     }]
                  }'>
                    {itemList.map((item, index) => this.renderPlaceCard(item, index))}
                </div>

                <div className="text-right text-muted pb-4 mb-2">
                    <small>{intl.getHTML('place_carousel_credits')}</small>
                </div>
            </div>
        );
    }

    renderPlaceCard(item, index) {
        let title = this.props.makeTitle ? this.props.makeTitle(item) : item;
        let link = this.props.makeLink ? this.props.makeLink(item) : "/";

        let imageUrl, authorLink, authorName;
        if (item.imageReference) {
            imageUrl = item.imageReference.imageUrl;
            authorLink = item.imageReference.referralAuthorUrl;
            authorName = item.imageReference.referralAuthorName;
        }

        return (
            <div key={'carousel_card_' + index}
                className="js-slide card border-1 shadow-sm mb-3">
                <div className="card-body h-100 p-0 position-relative">
                    {
                        imageUrl && <img className="card-img img-fluid h-100 rounded" src={imageUrl} alt={title} />
                    }
                    {
                        !imageUrl && <img className="card-img img-fluid h-100 rounded" src={PlaceHolder} alt={title} />
                    }
                </div>
                <div className="position-absolute w-100 h-100 gradient-overlay-half-dark-v1">
                    <div className="position-absolute right-0 bottom-0 left-0 p-4">
                        <h4>
                            <Link className="h4 text-white" onClick={this.props.onLinkClick} to={link}>{title}</Link>
                        </h4>
                        <hr />
                        <div className="small text-muted overflow-hidden text-nowrap">
                            <img width="12px" height="12px"
                                className="d-inline-block mr-2"
                                src={UnsplashLogo}
                                alt="Unsplash" />
                            <span><a className="text-muted"
                                target="_blank"
                                rel="noopener noreferrer"
                                href={authorLink}>{authorName}</a></span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default PlaceCarousel;